export default "__VITE_ASSET__BIs1eS9h__"